<template>
  <div class="site-wrapper">
    <div class="site-wrapper-inner">
      <div class="cover-container">
        <div class="inner cover">
          <img src="~/assets/images/quero_bolsa.svg" alt="Logo Quero Bolsa" width="200px">
          <h1 class="cover-heading">A página que você está<br> procurando não existe.</h1>
          <p class="lead">Não encontramos a página que você está tentando acessar.<br>Mas não desista ainda! Continue procurando sua bolsa de estudos.<br>O Quero Bolsa oferece bolsas de estudos de até 75% de desconto nas melhores faculdades do Brasil.</p>
          <p class="lead">
            <a href="/#universidades-parceiras" class="btn btn-lg btn-primary">Encontre Sua Bolsa</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '~/assets/stylesheets/utils/module.sass';

  a, a:focus, a:hover {
    color: #4D838C;
  }

  .btn-primary, .btn-primary:focus, .btn-primary:hover {
    color: $white;
    text-shadow: none;
    background-color: $color-secondary;
    border: none;
    border-radius: 30px;
  }

  body, html {
    height: 100%;
    background-color: $white;
  }

  body {
    color: #4b4841;
    text-align: center;
  }

  .site-wrapper {
    display: table;
    width: 100%;
    height: 100vh;
    min-height: 100%;
    text-align: center;
  }

  .site-wrapper-inner {
    display: table-cell;
    vertical-align: top;

    @media (min-width: 768px) {
      vertical-align: middle;
    }
  }

  .cover-container {
    margin-right: auto;
    margin-left: auto;

    @media (min-width: 768px) {
      width: 100%;
    }

    @media (min-width: 992px) {
      width: 700px;
    }
  }

  .inner {
    padding: 30px;
  }

  .cover {
    padding: 0 20px;
  }

  .cover .btn-lg {
    padding: 15px 30px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .cover-heading {
    margin-top: $space-s;
  }

</style>


<script>
export default {
  props: ['error'],
  layout: 'empty'
}
</script>
